var $ = require('./jquery');
var _ = require('lodash');
var Handlebars = require('handlebars');

var Template = Handlebars.compile($('#productTemplate').html());

var PRODUCTS_COUNT = 9;

var $productsArea = $('#products');
var $showMore = $('#showMore');
var $loader = $('#loader');
var $sort = $('#sort');

var products = window.exports.products ? Object.values(window.exports.products) : [];
var visibleProducts = 0;

$showMore.on('click', showProducts);
$sort.change(sortChanged);

function sortChanged() {
  var sort = $sort.children('option:selected').val();

  if ( 'new-old' === sort ) {
    products = _.sortBy(products, 'release_date').reverse();
  } else if ( 'old-new' === sort ) {
    products = _.sortBy(products, 'release_date');
  } else if ( 'title-a-z' === sort ) {
    products = _.sortBy(products, 'title');
  } else if ( 'title-z-a' === sort ) {
    products = _.sortBy(products, 'title').reverse();
  } else if ( 'author-a-z' === sort ) {
    products = _.sortBy(products, function(o) { return _.map(o.authors, 'name_sort'); });
  } else if ( 'author-z-a' === sort ) {
    products = _.sortBy(products, function(o) { return _.map(o.authors, 'name_sort'); }).reverse();
  } else if ( 'points-low-high' === sort ) {
    products = _.sortBy(products, function(o) { return parseInt(o.meta.points); });
  } else if ( 'points-high-low' === sort ) {
    products = _.sortBy(products, function(o) { return parseInt(o.meta.points); }).reverse();
  }

  $productsArea.empty();
  visibleProducts = 0;
  showProducts();
}

function showProducts() {
  $loader.removeClass('hidden');

  var productsToShow = products.slice(visibleProducts, visibleProducts + PRODUCTS_COUNT);

  for (var i = 0; i < productsToShow.length; i++) {
    $(Template(productsToShow[i])).appendTo($productsArea);
  }

  visibleProducts += productsToShow.length;
  $showMore.toggleClass('hidden', visibleProducts === products.length);

  $loader.addClass('hidden');

  return false;
}

if ( products.length ) {
  $productsArea.empty();
  showProducts();
}



//////////////////
// WEBPACK FOOTER
// ./views/js/category.js
// module id = 13
// module chunks = 2